import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointAnnotation, PointoramaAnnotation } from '../../../../potree/utils/PointoramaAnnotation';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncPointAnnotationsConfig({
  viewer,
  annotations,
  groups,
}: {
  viewer: NonNullable<RendererContextType['viewer']>;
  annotations: Annotation[];
  groups: Project['state']['groups'];
}): SyncConfig<Annotation, PointAnnotation> {
  const groupsByIdentifier = Object.fromEntries(groups.map((g) => [g.identifier, g]));

  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'POINT'),
    getSceneItems: () => viewer.scene.measurements.filter((m): m is PointAnnotation => m instanceof PointAnnotation && m.finished),
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry updates are handled by reactive property subscriptions
    create: (source, existing) => {
      const measure = new PointAnnotation({
        viewer,
        finished: true,
        identifier: source.identifier,
        selected: existing?.selected || false,
      });
      measure.groupName = (source.groupIdentifier && groupsByIdentifier[source.groupIdentifier]?.name) || '';
      return measure;
    },
    addToScene: (item) => viewer.scene.addMeasurement(item),
    removeFromScene: (item) => {
      if (item instanceof PointoramaAnnotation) {
        viewer.scene.removeMeasurement(item);
      }
    },
    afterCreate: (item) => {
      item.loadGeometryProperties();
    },
    chunkSize: 50,
  };
}
